var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.615 23C9.89887 23 8.48209 22.561 7.36463 21.683C6.25714 20.805 5.46893 19.6177 5 18.1211L9.01088 17.1633C9.10068 17.712 9.39002 18.1909 9.87891 18.6C10.3678 18.9991 10.8866 19.1986 11.4354 19.1986C11.8145 19.1986 12.2186 19.0939 12.6476 18.8844C13.0866 18.6748 13.4009 18.3406 13.5905 17.8816C13.7102 17.5923 13.78 17.2381 13.8 16.819C13.82 16.4 13.8299 15.9161 13.8299 15.3673V1H17.9605V15.3673C17.9605 16.0558 17.9556 16.6544 17.9456 17.1633C17.9456 17.6721 17.8957 18.151 17.7959 18.6C17.7061 19.039 17.5215 19.498 17.2422 19.9769C16.6336 21.0345 15.8404 21.8027 14.8626 22.2816C13.8848 22.7605 12.8023 23 11.615 23Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ);
export default __webpack_public_path__ + "static/media/J.d967fa6f63677d3cb7382e26f5928879.svg";
export { ForwardRef as ReactComponent };